import { DataBean } from "../DataBean";

export class RetroactiveEmployee extends DataBean {


    public async getRetroactiveEmployeeCatalog(idEmploymentBonus:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getRetroactiveEmployeeCatalog_Number", [idEmploymentBonus]);
    }

    

 
}